import { Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(60),
})`
  color: ${textMain};
  opacity: 0.5;
  margin-bottom: 50%;
`;

export const Title = styled(Typography).attrs({
  variant: 'xxl',
})`
  font-weight: 600;
`;
export const Description = styled(Typography).attrs({
  variant: 'md',
})`
  line-height: 150%;
`;
